import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IVehicle } from '@interfaces/vehicle.interface';
import { Api } from '@root/core/constants/api-routes.constants.';
import { CONFIG } from '@root/core/constants/app.constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class VehiclesService {
  server = CONFIG.API_SERVER;
  api = Api.VEHICLE

  constructor(private httpClient: HttpClient) { }

  getAll(): Observable<IVehicle[]> {
    const url = ''
    return this.httpClient.get<IVehicle[]>(url)
  }
  getById(id: number): Observable<IVehicle[]> {
    const url = `${id}`
    return this.httpClient.get<IVehicle[]>(url)
  }
  getByLicensePlate(licensePlate: string): Observable<IVehicle> {
    const url = `${this.server}${this.api}/license-plate/${licensePlate}`
    return this.httpClient.get<IVehicle>(url)
  }
  create(vehicle: IVehicle): Observable<IVehicle> {
    const url = `${this.server}${this.api}`
    return this.httpClient.post<IVehicle>(url, vehicle)
  }
  update(vehicle: IVehicle): Observable<IVehicle> {
    const url = ``
    return this.httpClient.put<IVehicle>(url, vehicle)
  }
  delete(id: number): Observable<any> {
    const url = `${id}`
    return this.httpClient.delete<IVehicle>(url)
  }
}
